import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryCreator } from '@utils/baseQueryCreator';

import { ENV } from '@constants';

export const playerReportingServiceApiSlice = createApi({
  endpoints: () => ({}),
  refetchOnReconnect: true,
  reducerPath: 'reportingService',
  baseQuery: (...arguments_) =>
    baseQueryCreator(ENV.VITE_PLAYER_REPORTING_SERVICE_API_URL)(...arguments_),
});
